<template>
    <div>
        <modal
            name="markAsCompleteModal"
            classes="v-modal-sec linklca"
            :min-width="200"
            :min-height="200"
            :scrollable="true"
            :reset="true"
            width="1300px"
            height="auto"
        >
        <div class="v-modal">
        <div class="popup-header fromDetailsPage"> 
            <h2 class="popup-title">Mark as Complete</h2>
            <span @click="$modal.hide('markAsCompleteModal');hideMe()">
            <em class="material-icons">close</em>
            </span>
        </div>
        <form data-vv-scope="newCaseNumberForm" @submit.prevent @keydown.enter.prevent>
          <div class="linklca_form" @click="formErrors=''">
            <div class="form-container pad0">
                <fileUploadNote :fileNote="false" :success="true" :successMsg="checkProperty(invoiceRespose, 'message')" />
                <div class="accordian-table custom-table no-wrap relative">
                    <vs-table :data="selectedInvoiceList ">
                        <template v-if="selectedInvoiceList.length > 0" slot="thead">     
                            <vs-th class="mw-280"> Case No </vs-th>
                            <vs-th> Case Type </vs-th>
                            <vs-th> Amount($) </vs-th>
                            <vs-th> Issued To </vs-th>
                            <vs-th > Issued On </vs-th>
                        </template>
                        <template slot-scope="{ data }">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="vs-table--tr">
                                <vs-td>
                                    <vs-checkbox
                                        :name="'selected_'+tr.index"
                                        v-model="tr.markasComplete" class=""></vs-checkbox>
                                    <div  > {{ checkProperty(tr, 'beneficiaryCustomId') }} </div>
                                </vs-td>
                                <vs-td class="td_label" >
                                    <div >
                                        {{ checkProperty(tr, 'petitionType') }} <br />
                                        <small> {{ checkProperty(tr, 'subTypeName') }} </small>
                                      </div>
                                </vs-td>
                                <vs-td >
                                    <template v-if="tr && (tr.invoiceAmount || tr.invoiceAmount == 0) ">{{formatprice(tr.invoiceAmount)}}</template>
                                </vs-td>
                                <vs-td >
                                    <div > {{ checkProperty(tr, 'issuedToDetails') }} </div>
                                </vs-td>  
                                <vs-td >
                                    <div > {{ checkProperty(tr, 'updatedOn')|formatDate }} </div>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>            
                <div class="text-danger text-sm formerrors my-2" v-show="formErrors">
                    <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius"
                        icon-pack="IntakePortal" icon="IP-information-button" active="true">{{ formErrors }}</vs-alert>
                </div>
            </div>
            <div class="popup-footer relative">
                <span class="loader" v-if="loading"><img src="@/assets/images/main/loader.gif" /></span>
                <vs-button color="dark" @click="hideMe()" class="cancel" type="filled">Cancel</vs-button>
                <vs-button :disabled="loading || !enableMarkComplete" color="success" @click="submitForm()" class="save" type="filled">
                   Submit
                </vs-button>
            </div>
          </div>
        </form>
      </div>
        </modal>
    </div>
</template>
<script>

import fileUploadNote from "@/views/common/fileUploadNote.vue";
const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});
export default {
    components:{
        fileUploadNote,
    },
    data: () => ({
        loading:false,
        selectedInvoiceList:[],
        formErrors:'',

    }),
    methods:{
        formatprice(amount) {
            return formatter.format(amount);
        },
        submitForm(){
            let payLoad = {
                caseIds:[]
            }
            let selectedIds = [];
            _.forEach(this.selectedInvoiceList, (itm)=>{
                let obj = {
                    '_id':'',
                    'entityType':'',
                }
                if(itm['markasComplete']){
                    obj['_id'] = itm['_id'];
                    obj['entityType'] = itm['entityType']
                    // ids.push(itm['_id'])
                    selectedIds.push(obj);
                    obj = {
                        '_id':'',
                        'entityType':'',
                    }
                }
            });
            let path = '/invoices/invoice-mark-as-complete-list'
            if(selectedIds && selectedIds.length>0){
                payLoad['caseIds'] = selectedIds;
                this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((response) => {
                    this.showToster({ message: response.message, isError: false });
                    this.hideMe()
                }).catch((err)=>{
                    this.showToster({ message: err, isError: true });
                })
            }else{
                this.showToster({ message: 'Select atleast one case to Mark as Complete', isError: true });
            }
            

        },
        hideMe(){
            this.$modal.hide('markAsCompleteModal');
            this.$emit('hideMe')
        }
    },
    mounted(){
        // console.log(JSON.stringify(this.invoiceRespose)) 662292c959029bbb8827a658
        if(this.invoicesList && this.invoicesList.length>0){
            let tempList = this.invoicesList;
            let list = [];
            if(this.invoiceRespose && this.checkProperty(this.invoiceRespose, 'items') && this.checkProperty(this.invoiceRespose, 'items', 'failure') && this.checkProperty(this.invoiceRespose['items'], 'failure', 'length')>0 ){
                _.forEach(tempList, (tItem)=>{
                    if(this.invoiceRespose['items']['failure'].indexOf(tItem['_id'])<=-1){
                        list.push(tItem)
                    }
                })
            }else{
                list = _.cloneDeep(tempList)
            }
            // let list = this.invoicesList;
            if(list && list.length>0){
                _.forEach(list, (item)=>{
                    item['markasComplete'] = true;
                    if(item['feeDetails'] && item['feeDetails'].length>0){
                        let amont = 0;
                        _.forEach(item['feeDetails'], (fee)=>{
                            if(fee['isSelected'] && !fee['isAlreadyExist']){
                                if(amont>0){
                                    amont = amont+parseInt(fee['amount'])
                                }else{
                                    amont = parseInt(fee['amount'])
                                }
                            }
                        })
                        item['invoiceAmount'] = amont
                    }
                });
                list = _.cloneDeep(list)
                this.selectedInvoiceList = list
            }
        };
        this.$modal.show('markAsCompleteModal')
    },
    props: {
        invoicesList:null,
        invoiceRespose:null,
    },
    computed:{
        enableMarkComplete(){
            let returnVal = false;
            if(this.checkProperty(this.selectedInvoiceList, 'length')>0){
                let findObj = _.find(this.selectedInvoiceList, {'markasComplete':true});
                if(findObj){
                    returnVal = true;
                }
            }
            return returnVal
        },
    }
}
</script>